export default __webpack_public_path__ + "static/media/Plissee 22 mm seitlich ausmessen.470c4a98.jpg";